module.exports = __webpack_public_path__ + "assets/img/2.7aa0506c.jpg";